import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function ScreengrabLightbox({ image, title, subtitle, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!image) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-full bg-gmod-dark/80 text-gmod-white hover:bg-gmod-lighter border border-gmod-lighterer z-10"
        aria-label="Закрыть"
      >
        <X className="w-6 h-6" />
      </button>
      {(title || subtitle) && (
        <div className="absolute top-4 left-4 z-10 text-gmod-white bg-black/50 rounded-lg px-3 py-2 max-w-[70vw]">
          {title && <div className="font-semibold text-lg">{title}</div>}
          {subtitle && <div className="text-sm opacity-70">{subtitle}</div>}
        </div>
      )}
      <img
        src={`data:image/jpeg;base64,${image}`}
        alt="Скриншот"
        className="max-w-[96vw] max-h-[96vh] w-auto h-auto object-contain rounded shadow-2xl cursor-zoom-out"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
